export default "__VITE_ASSET__Dv6H6aqs__"